module.exports = __webpack_public_path__ + "static/media/premium-room-pic.865f664a.png";